import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router';
import Toast from '../../components/Toast';
import Header from '../../components/Header';
import Segment from '../../components/Segment';
import SidebarWrapper from '../../components/SidebarWrapper';
import PageTitle from '../../components/PageTitle';
import OptInOrOutRatingsModal from './opt-in-or-out-ratings-modal';
import RepVisitsCalendarEventDetailsSideBar from '../RepVisitsCalendarEventDetailsSideBar';
import messages from './messages';

import './styles.css';

class RepVisitsRatings extends React.PureComponent {
  static propTypes = {
    intl: PropTypes.object,
    children: PropTypes.node,
    viewer: PropTypes.shape({
      heAccount: PropTypes.object.isRequired,
    }).isRequired,
    optInorOutRatings: PropTypes.func.isRequired,
  };

  state = {
    optedOutOfRepVisitsRatings: this.props.viewer.heAccount.repVisitsSettings.optedOutOfRepVisitsRatings,
    notification: null,
    openModal: false,
    selectedEvent: null,
    sidebarVisible: false,
  };

  successOnNotification =
    <Toast
      active
      title=""
      kind="success"
      description={this.props.intl.formatMessage(messages.successTurnedOnMessage)}
      onDeactivate={() => this.setState({ notification: null })}
    />;

  successOffNotification =
    <Toast
      active
      title=""
      kind="success"
      description={this.props.intl.formatMessage(messages.successTurnedOffMessage)}
      onDeactivate={() => this.setState({ notification: null })}
    />;

  failureNotification =
    <Toast
      active
      title=""
      kind="error"
      description={this.props.intl.formatMessage(messages.failureTurnedOnOffMessage)}
      onDeactivate={() => this.setState({ notification: null })}
    />;

  displayNotification = (isSuccess, optOut) => {
    this.setState({ optedOutOfRepVisitsRatings: optOut });
    const { optedOutOfRepVisitsRatings } = this.state;
    if (isSuccess) {
      this.setState({ notification: optedOutOfRepVisitsRatings ? this.successOffNotification : this.successOnNotification });
    } else {
      this.setState({ notification: this.failureNotification });
    }
  };

  closeSideBar = () => {
    this.setState({ sidebarVisible: false });
  };

  showSideBar = (event) => {
    this.setState({ sidebarVisible: true, selectedEvent: event });
  };

  closeModal = () => {
    this.setState({ openModal: false });
  };

  showModal = () => {
    this.setState({ openModal: true });
  };

  render() {
    const { notification, selectedEvent, sidebarVisible, optedOutOfRepVisitsRatings } = this.state;
    const { viewer, optInorOutRatings } = this.props;
    return (
      <SidebarWrapper>
        <SidebarWrapper.Bar visible={sidebarVisible} onClose={this.closeSideBar} hideCloseButton={false}>
          <RepVisitsCalendarEventDetailsSideBar
            visible
            onDismissNotification={this.closeSideBar}
            event={selectedEvent}
          />
        </SidebarWrapper.Bar>
        <SidebarWrapper.Content dimmed={sidebarVisible} onClick={this.closeSideBar}>
          <PageTitle subTitle="Visit Feedback" title="RepVisits" category="Intersect" />
          <div styleName="heading-container">
            {notification}
            <Header as="h1" styleName="header" id="pageTitle">
              <FormattedMessage {...messages.visitFeedback} />
            </Header>
            <div>
              <FormattedMessage
                {...optedOutOfRepVisitsRatings ? messages.turnedOff : messages.turnedOn}
                values={{
                  strong: (...chunks) => <strong>{chunks}</strong>,
                }}
              />
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <Link href="#" onClick={this.showModal} data-cy="repvisits-ratings-feedback-toggle-button" styleName="on-off-btn">
                <FormattedMessage {...optedOutOfRepVisitsRatings ? messages.turnOn : messages.turnOff} />
              </Link>
            </div>
            <Segment>
              {this.props.children}
            </Segment>
          </div>
          <OptInOrOutRatingsModal
            displayNotification={this.displayNotification}
            open={this.state.openModal}
            onClose={this.closeModal}
            heAccount={viewer.heAccount}
            optInorOutRatings={optInorOutRatings}
          />
        </SidebarWrapper.Content>
      </SidebarWrapper>
    );
  }
}

export default injectIntl(RepVisitsRatings);
